import { ApiContext } from './api-context';
import { useContextSelector } from '../../use-context-selector';
import { isShallowEqual } from '../../../common/utils/is-shallow-equal';
/**
 * @internal
 * Optimized hook which will trigger rerender only if result is not shallowly equal.
 * Avoid creating new values in it. Don't:
 * const { myNevVal } = useApi(state => ( { nyNewVal: () => state.soemething }));
 */
export function useApi(mapRuntimeToProps) {
    return useContextSelector(ApiContext, (ctx) => mapRuntimeToProps(ctx.state, ctx.actions, ctx.host, ctx), isShallowEqual);
}
//# sourceMappingURL=use-api.js.map